import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore/lite";

// TODO: save as env variables
const firebaseConfig = {
  apiKey: "AIzaSyBkmWkaPgIx3w_b2_F_2_ZO7-Urbe3lTxo",
  authDomain: "omniprint-46877.firebaseapp.com",
  projectId: "omniprint-46877",
  storageBucket: "omniprint-46877.appspot.com",
  messagingSenderId: "287163863199",
  appId: "1:287163863199:web:3ac94cd4ab784292f912aa",
  measurementId: "G-YJ5J4X5QE0",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const AUTHORS_COLLECTION_NAME = "authors";
const BOOKS_COLLECTION_NAME = "books";
const TYPES_COLLECTION_NAME = "types";

function getItemData(item) {
  if (!item.exists()) {
    return undefined;
  }
  return { key: item.id, ...item.data() };
}

async function readData(collectionName) {
  return getDocs(collection(db, collectionName)).then((snapshot) =>
    snapshot.docs.map((item) => getItemData(item)),
  );
}

async function readDataWithQuery(
  collectionName,
  queryField,
  queryOperator,
  queryValue,
) {
  return getDocs(
    query(
      collection(db, collectionName),
      where(queryField, queryOperator, queryValue),
    ),
  ).then((snapshot) => snapshot.docs.map((item) => getItemData(item)));
}

export async function getAuthors() {
  return readData(AUTHORS_COLLECTION_NAME);
}

export async function getReleasedBooks() {
  return readDataWithQuery(
    BOOKS_COLLECTION_NAME,
    "releaseDate",
    "<=",
    new Date(),
  );
}

export async function getUpcomingBooks() {
  return readDataWithQuery(
    BOOKS_COLLECTION_NAME,
    "releaseDate",
    ">",
    new Date(),
  );
}

async function getBook(id) {
  const book = doc(db, BOOKS_COLLECTION_NAME, id);
  return getItemData(await getDoc(book));
}

export async function getAuthorForBook(id) {
  const book = await getBook(id);
  return getItemData(await getDoc(book.author));
}

export async function getTypes() {
  return readData(TYPES_COLLECTION_NAME);
}
